__turbopack_context__.v({
  "background": "CollectionSectionPL-module___GY0MG__background" + " " + __turbopack_context__.i(13628)["background"],
  "section": "CollectionSectionPL-module___GY0MG__section" + " " + __turbopack_context__.i(13628)["section"],
  "topBar": "CollectionSectionPL-module___GY0MG__topBar" + " " + __turbopack_context__.i(13628)["topBar"],
});
